import _cloneDeep from 'lodash/cloneDeep'
import {
  GET_CLIENTS_REQUESTED,
  GET_CLIENTS_SUCCESS,
  CLIENTS_FAILED,
  PUT_COMPOSEPROFILES_REQUESTED,
  PUT_COMPOSEPROFILES_SUCCESS,
  PUT_COMPOSEPROFILES_FAILED,
  CLIENTS_RESET,
  PRINT_CLIENT_PROFILE,
  PRINT_CLIENT_PROFILE_FAILED,
} from '../actions/actionTypes'

const initialState = {
  clients: [],
  loading: false,
  commonError: '',
  isBack: false,
}

const clientsReducer = (state = _cloneDeep(initialState), action) => {
  switch (action.type) {
    case GET_CLIENTS_REQUESTED:
      return {
        ...state,
        loading: true,
        commonError: '',
        clients: []
      }
    case GET_CLIENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        isBack: true,
        clients: [...action.payload]
      }
    case CLIENTS_FAILED:
      return {
        ...state,
        loading: false,
        commonError: action.payload,
        isBack: false
      }
    case PUT_COMPOSEPROFILES_REQUESTED:
      return {
        ...state,
        loading: true,
        commonError: '',
      }
    case PUT_COMPOSEPROFILES_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case PUT_COMPOSEPROFILES_FAILED:
      return {
        ...state,
        loading: false,
        commonError: action.payload,
      }
    case PRINT_CLIENT_PROFILE:
        return {
          ...state,
          commonError: '',
        }
    case PRINT_CLIENT_PROFILE_FAILED:
        return {
          ...state,
          commonError: action.payload,
        }
    case CLIENTS_RESET:
      return _cloneDeep(initialState)

    default:
      return state
  }
}

export default clientsReducer 